import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button, Container } from '@mui/material';
import { Home as HomeIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAppNavigation } from '../../App';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const { goToHome } = useAppNavigation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    console.log('🏠 Clicando em Ir para Home');
    
    // Usar React Router para navegar para a rota principal
    console.log('🧭 Navegando com React Router para "/"');
    navigate('/');
    
    // Também chamar o goToHome para atualizar o estado interno
    console.log('🏠 Chamando goToHome interno');
    goToHome();
  };

  const handleGoBack = () => {
    console.log('🔙 Clicando em Voltar');
    window.history.back();
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '6rem', sm: '8rem', md: '10rem' },
            fontWeight: 'bold',
            color: 'primary.main',
            lineHeight: 1,
            mb: 2
          }}
        >
          404
        </Typography>

        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            fontWeight: 'medium',
            color: 'text.primary',
            mb: 2
          }}
        >
          {t('notFound.title')}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '1rem', sm: '1.1rem' },
            color: 'text.secondary',
            mb: 4,
            maxWidth: '500px'
          }}
        >
          {t('notFound.description')}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: { xs: 'column', sm: 'row' },
            width: { xs: '100%', sm: 'auto' }
          }}
        >
          <Button
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{
              px: 3,
              py: 1.5,
              fontSize: '1rem',
              minWidth: { xs: '100%', sm: '160px' }
            }}
          >
            {t('notFound.goHome')}
          </Button>

          <Button
            variant="outlined"
            size="large"
            startIcon={<ArrowBackIcon />}
            onClick={handleGoBack}
            sx={{
              px: 3,
              py: 1.5,
              fontSize: '1rem',
              minWidth: { xs: '100%', sm: '160px' }
            }}
          >
            {t("common.back")}
          </Button>
        </Box>

        <Typography
          variant="caption"
          sx={{
            mt: 4,
            color: 'text.secondary',
            fontSize: '0.9rem'
          }}
        >
          {t('notFound.contactSupport')}
        </Typography>
      </Box>
    </Container>
  );
};

export default NotFoundPage;